import html2canvas from "html2canvas"
import jsPDF from "jspdf"

/**
 * Download a form element as a multi-page A4 PDF.
 * Preserves on-screen proportions (fits page width with margins; does not shrink oddly).
 */
export const downloadFormAsPdf = async (element, filename = "Form.pdf") => {
  if (!element) {
    throw new Error("Form element not found")
  }

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    allowTaint: true,
    logging: false,
    backgroundColor: "#ffffff",
    windowWidth: element.scrollWidth,
    windowHeight: element.scrollHeight,
  })

  const imgData = canvas.toDataURL("image/png")
  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  })

  const pageWidth = pdf.internal.pageSize.getWidth()
  const pageHeight = pdf.internal.pageSize.getHeight()
  const margin = 10
  const contentWidth = pageWidth - margin * 2
  const contentPageHeight = pageHeight - margin * 2
  const imgHeight = (canvas.height * contentWidth) / canvas.width

  let heightLeft = imgHeight
  let position = margin

  pdf.addImage(imgData, "PNG", margin, position, contentWidth, imgHeight)
  heightLeft -= contentPageHeight

  while (heightLeft > 0) {
    position = margin - (imgHeight - heightLeft)
    pdf.addPage()
    pdf.addImage(imgData, "PNG", margin, position, contentWidth, imgHeight)
    heightLeft -= contentPageHeight
  }

  pdf.save(filename)
}

export const buildFormPdfFilename = ({ title, adminName, year }) => {
  const safeTitle = (title || "Form").replace(/[^\w\-]+/g, "-")
  const safeName = (adminName || "Admin").replace(/[^\w\-]+/g, "-")
  const safeYear = year || new Date().getFullYear()
  return `${safeTitle}-${safeName}-${safeYear}.pdf`
}
